import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CollectionConfigService {
  constructor() { }
  SapNotification: any = [

    // values list (dropDown)
    { name: 'NotificationType', displayName: 'Notification Type', operators: ['in','not in'], values: [], isDropDown: true },
    { name: 'PlanGroup', displayName: 'Plan Group', operators: ['in','not in'], values: [], isDropDown: true },
    { name: 'PlantSection', displayName: 'Plant Section', operators: ['in','not in'], values: [], isDropDown: true },
    { name: 'FunctionalLoc', displayName: 'Functional Loc', operators: ['in','not in'], values: [], isDropDown: true },
    { name: 'Equipment', displayName: 'Equipment', operators: ['in','not in'], values: [], isDropDown: true },
    { name: 'MaintenancePlant', displayName: 'Maintenance Plant', operators: ['in','not in'], values: [], isDropDown: true },
    { name: 'CreatedByName', displayName: 'Created By Name', operators: ['in','not in'], values: [], isDropDown: true },
    { name: 'CompletedByName', displayName: 'Completed By Name', operators: ['in','not in'], values: [], isDropDown: true },
    // Date fields (date Picker)
    { name: 'CompletedOn', displayName: 'Completed On', isDateField: true, operators: ['<', '<=', '=', '>=', '>', '!='], categorical: false },
    { name: 'ChangedOn', displayName: 'Changed On', isDateField: true, operators: ['<', '<=', '=', '>=', '>', '!='], categorical: false },
    { name: 'CreatedOn', displayName: 'Created On', isDateField: true, operators: ['<', '<=', '=', '>=', '>', '!='], categorical: false },
    { name: 'Notifdate', displayName: 'Notifdate Date', isDateField: true, operators: ['<', '<=', '=', '>=', '>', '!='], categorical: false },

    // Number fields (Input fields)
    { name: 'WarehouseCost', displayName: 'Warehouse Cost', isInputField: true, operators: ['<', '<=', '=', '>=', '>', '!='] },
    { name: 'InternalLabourCost', displayName: 'Internal Labour Cost', isInputField: true, operators: ['<', '<=', '=', '>=', '>', '!='] },
    { name: 'ExternalLabourCost', displayName: 'External Labour Cost', isInputField: true, operators: ['<', '<=', '=', '>=', '>', '!='] },
    { name: 'ExternalServiceCost', displayName: 'External Service Cost', isInputField: true, operators: ['<', '<=', '=', '>=', '>', '!='] }
  ];

  private dataSubject = new BehaviorSubject<any>(this.SapNotification); // Initialize with default JSON data
  data$ = this.dataSubject.asObservable();

  getData(): any {  // Get current value
    return this.dataSubject.getValue();
  }

  updateData(newData: any) {   // Update the data
    this.dataSubject.next(newData);
  }
}